/**
 * Global role authority directive
 * Used for fine-grained control of component permissions
 * @Example v-permR="tester" 不能与 v-if 同时使用，容易出问题
 */
import { hasPermR, hasPermU } from '@/utils/permission';
import type { App, Directive, DirectiveBinding } from 'vue';

const permUDirectives: Directive = {
  mounted: (el: Element, binding: DirectiveBinding<any>) => {
    const { value } = binding;
    if (!value) {
      return;
    }
    if (!hasPermU(value)) {
      el.parentNode?.removeChild(el);
    }
  },
};

const permRDirectives: Directive = {
  mounted: (el: Element, binding: DirectiveBinding<any>) => {
    const { value } = binding;
    if (!value) {
      return;
    }
    if (!hasPermR(value)) {
      el.parentNode?.removeChild(el);
    }
  },
};

export function setupPermissionDirective(app: App) {
  app.directive('permU', permUDirectives);
  app.directive('permR', permRDirectives);
}
